import { render, staticRenderFns } from "./conversation-item.vue?vue&type=template&id=e2324668&scoped=true&"
import script from "./conversation-item.vue?vue&type=script&lang=js&"
export * from "./conversation-item.vue?vue&type=script&lang=js&"
import style0 from "./conversation-item.vue?vue&type=style&index=0&id=e2324668&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2324668",
  null
  
)

export default component.exports